export default "__VITE_ASSET__352VLZrn__"